import apptimedRequest from "../../../connections/apptimedRequest";

var testReportSource = {
    fetchViewReport: function (uid) {
        return apptimedRequest.get(`labs/appointment/${uid}/report`);
    },
};

export default testReportSource;